import { connect } from 'react-redux'
import PupilsBulkAction from './pupils-bulk-action'
import {
  getSelectedPupilsIdsArray,
  isShowingSelected
} from '../../../pupils-component/pupils-component-redux/pupils-component.selectors'
import {
  showSelected,
  unsetShowSelected
} from '../../../pupils-component/pupils-component-redux/pupils-component.actions'
import { openAgeGroupDialog } from '../dialogs/set-age-group/set-age-group.actions'
import { openAddToGroupDialog } from '../../../add-to-group/add-to-group.actions'
import { openRemoveFromGroupDialog } from '../dialogs/remove-from-group/remove-from-group.actions'
import {
  retirePupil,
  incrementAgeGroup,
  addPermission,
  removePermission,
  exportCSV
} from '../../../../stores/pupils/pupils.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => ({
  editable: me.account.policy.can_manage_students,
  selectedPupils: getSelectedPupilsIdsArray(state),
  showingSelected: isShowingSelected(state),
  canUpdatePermissions: me.account.policy.can_update_school_leader_permissions
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  showSelected: () => dispatch(showSelected()),
  showAll: () => dispatch(unsetShowSelected()),
  onSetAgeGroup: () => dispatch(openAgeGroupDialog(stateProps.selectedPupils)),
  onAddToGroup: () => dispatch(openAddToGroupDialog(stateProps.selectedPupils)),
  onRemoveFromGroup: () =>
    dispatch(openRemoveFromGroupDialog(stateProps.selectedPupils)),
  retirePupils: () =>
    stateProps.selectedPupils.forEach(id =>
      dispatch(retirePupil(id)).catch(errorHandler)
    ),
  onIncrementAge: () =>
    stateProps.selectedPupils.forEach(id =>
      dispatch(incrementAgeGroup(id)).catch(errorHandler)
    ),
  addPermission: () =>
    stateProps.selectedPupils.forEach(id =>
      dispatch(addPermission(id)).catch(e => null)
    ),
  removePermission: () =>
    stateProps.selectedPupils.forEach(id =>
      dispatch(removePermission(id)).catch(e => null)
    ),
  onExportCSV: () =>
    dispatch(exportCSV(stateProps.selectedPupils)).then(
      resp => (window.location = resp.data.url)
    )
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(PupilsBulkAction)
)
